import React from 'react';
import WhiteboxPage from '../components/WhiteboxPage';
import { FormattedMessage } from 'react-intl';
import errorImage from '../images/Error.svg';
import { VerificationType } from '../types';

import TallButton from '../components/TallButton';
import ButtonContainer from '../components/ButtonContainer';
import styled from '@emotion/styled';
import {
  useAnalyticsClient,
  usePageViewedEvent,
} from '../utilities/analytics/analytics-web-client';
import { useNavigateSoftOrHard } from '../utilities/hooks/useNavigateSoftOrHard';

const MessageContainer = styled.div`
  margin-bottom: 24px;
`;

export type VerifyOrReverifyEmailExpiredTokenErrorPageProps = {
  recoverUrl: string;
  verificationType: VerificationType;
};

export const VerifyOrReverifyEmailExpiredTokenErrorPage = ({
  recoverUrl,
  verificationType,
}: VerifyOrReverifyEmailExpiredTokenErrorPageProps) => {
  const navigate = useNavigateSoftOrHard();
  const analyticsClient = useAnalyticsClient();
  const pageId = 'verifyEmailExpiredTokenErrorPage';

  usePageViewedEvent(pageId, { flow: verificationType });

  const recover = () => {
    analyticsClient.buttonClickedEvent(pageId, 'resendVerificationEmail', {
      flow: verificationType,
    });
    navigate(recoverUrl);
  };

  return (
    <WhiteboxPage
      pageId={pageId}
      header={
        <div>
          <MessageContainer>
            <FormattedMessage
              id="reverify.email.expire.title"
              defaultMessage="Resend verification email"
              tagName="h5"
            />
          </MessageContainer>
          <img src={errorImage} width="99" alt="" />
        </div>
      }>
      <FormattedMessage
        id="reverify.email.expire.body"
        defaultMessage="The link to verify your account has expired."
      />
      <ButtonContainer>
        <TallButton
          appearance="primary"
          id="reverify.email.expire.button"
          isFullWidth
          onClick={recover}>
          <FormattedMessage
            id="reverify.email.expire.button"
            defaultMessage="Resend verification email"
          />
        </TallButton>
      </ButtonContainer>
    </WhiteboxPage>
  );
};

export default VerifyOrReverifyEmailExpiredTokenErrorPage;
